import { ClassificationStatus } from '../Features/Classification/enum/ClassificationStatus';
import { NewsStatus } from '../Features/Classification/enum/NewsStatus';
import { JournalistModel } from './JournalistModel';

export interface NewsModel {
    id: number,
    title: string,
    centimeter: number,
    clientId: number,
    clientDescription?: string,
    clipperId: number,
    clipperLink: string,
    journalistSpreadsheetName: string,
    journalists: JournalistModel[],
    newsLink: string,
    vehicle: string,
    publishDate: Date | null,
    clientCodeMetric: number | null,

    vehicleCodeMetric: number | null,
    mediaCodeMetric: number | null,
    vehicleId: number | null,
    mediaId: number | null,
    vehicleOriginDictionary: boolean,
    status: NewsStatus,
    
    metricIds?: string,
    classificationId: number | null,
    classificationStatus: ClassificationStatus | null,

    detached: boolean
}

export const newsModelInitial: NewsModel = {
    id: 0,
    title: '',
    centimeter: 0,
    clientId: 0,
    clipperId: 0,
    clipperLink: '',
    journalistSpreadsheetName: '',
    newsLink: '',
    vehicle: '',
    publishDate: null,
    vehicleCodeMetric: 0,
    mediaCodeMetric: 0,
    vehicleId: 0,
    mediaId: 0,    
    vehicleOriginDictionary: false,
    status: 0,
    clientCodeMetric: null,
    journalists: [],
    classificationId: null,
    classificationStatus: null,
    detached: false
};
